/** @format */

import styled, { css } from 'styled-components';

/** @format */
export const SuitableForCouplesWrapper = styled.div<{ $hasPromo?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.75rem;
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ $hasPromo }) =>
      $hasPromo
        ? css`
            flex-wrap: wrap;
            flex-direction: column;
            gap: 0;
          `
        : css`
            font-size: 0.75rem;
            margin-top: 0rem;
          `}
  }
`;

export const TooltipGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  a {
    cursor: pointer;
  }

  #suitable-for-couples-tooltip {
    display: flex;
    padding: 0.5rem 0.75rem;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    background: var(--White, #fff);
    max-width: 17.125rem;
    border-radius: 0.5rem;

    color: var(--Gray-700, #344054);
    text-align: center;
    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.125rem; /* 150% */

    opacity: 1;

    /* Shadow/lg */
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }
`;

export const TooltipTitle = styled.span<{ $hasPromo?: boolean }>`
  color: var(--Gray-900, #101828);

  /* Text sm/Medium */
  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem; /* 142.857% */

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ $hasPromo }) =>
      !$hasPromo &&
      css`
        font-size: 0.75rem;
      `}
  }
`;

export const CouplePrice = styled.span<{ $hasPromo?: boolean }>`
  color: var(--Pink-600, #e56e69);
  text-align: right;

  /* Text md/Semibold */
  font-family: ${({ theme }) => theme.font.body};
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem; /* 150% */

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ $hasPromo }) =>
      !$hasPromo &&
      css`
        font-size: 0.875rem;
      `}
  }
`;
